import React from 'react'
import { Grid, GridCell, GridRow } from '@mobi/component-library/Legacy/Grid'
import { ButtonBlock } from '@core/Components/Buttons/ButtonBlock'
import { NoticeBox } from '@core/Components/NoticeBox'
import type { PromptForUserDecisionProps } from './helpers'

export const PromptForUserDecision: React.FC<PromptForUserDecisionProps> = ({
  handleSelection,
  testId,
  buttons,
  title,
  subtitle,
}) => {
  return (
    <div data-testid={testId}>
      <NoticeBox title={title} subtitle={subtitle} noticeBoxType='Warning' />
      <Grid>
        <GridRow>
          {buttons.map(({ label, color }) => (
            <GridCell padding='1rem' key={label}>
              <ButtonBlock onClick={() => handleSelection(label)} color={color}>
                {label}
              </ButtonBlock>
            </GridCell>
          ))}
        </GridRow>
      </Grid>
    </div>
  )
}
